<div class="animated fadeIn">
	<!-- <h3>Admin Panel</h3>
	<br/> -->
	<div class="row">
		<div class="col-lg-12">
			<div class="card">
				<div class="card-body" style="min-height: 600px;">
					<h4 class="box-title"> Approval Page </h4>
					<br/>

					<div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont1"> 
						<div class="row form-group">
							<div class="col col-md-10">
								Public Dashboard Note
							</div>
							<div class="col col-md-2">
								&nbsp;
							</div>
						</div>
						<div class="row form-group">
							<div class="col col-md-10">
								<input name="config2"  id="config2" [(ngModel)]="configVal" class="form-control-sm form-control" required=""  />
							</div>
							<div class="col col-md-2">
								<div class="form-actions form-group">
									<button type="submit" class="btn btn-primary btn-sm" (click)="updateConfig()" >Update</button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>Premium & Policy Data</h4>
                                </div>
                                <div class="card-body">
                                    <div class="default-tab">
                                        <nav>
                                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                                <a [ngClass]="{'nav-item': true, 'nav-link': true, 'active':tabName === 'Segment' }"  id="nav-home-tab" data-toggle="tab" (click)="changeTab('Segment')" role="tab" aria-controls="nav-home" aria-selected="true">Segment</a>
                                                <a [ngClass]="{'nav-item': true, 'nav-link': true, 'active':tabName === 'Form 1' }" id="nav-profile-tab" data-toggle="tab" (click)="changeTab('Form 1')" role="tab" aria-controls="nav-profile" aria-selected="false">Form 1</a>
                                                <a [ngClass]="{'nav-item': true, 'nav-link': true, 'active':tabName === 'Form 2' }" id="nav-contact-tab" data-toggle="tab" (click)="changeTab('Form 2')" role="tab" aria-controls="nav-contact" aria-selected="false">Form 2</a>
                                                <a [ngClass]="{'nav-item': true, 'nav-link': true, 'active':tabName === 'Form 3' }" id="nav-contact-tab" data-toggle="tab" (click)="changeTab('Form 3')" role="tab" aria-controls="nav-contact" aria-selected="false">Form 3</a>
                                                <a [ngClass]="{'nav-item': true, 'nav-link': true, 'active':tabName === 'Form 5' }" id="nav-contact-tab" data-toggle="tab" (click)="changeTab('Form 5')" role="tab" aria-controls="nav-contact" aria-selected="false">Form 5</a>
                                            </div>
                                        </nav>
                                        <div class="tab-content pl-3 pt-2" id="nav-tabContent">
                                            <div [ngClass]="{'tab-pane': true, 'fade': true, 'show':true, 'active':tabName === 'Segment' }"  id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                            	<div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getMonthCheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
		                                            <thead>
		                                                <tr role="row">
		                                                    <th><input type="checkbox" name="selectAll" (change)="selectUnselectMonth($event)"></th>
		                                                    <th>Insurer</th>
		                                                    <th>Month</th>
		                                                    <th>Year</th>
		                                                    <th>LOB</th>
		                                                    <th>Premium </th>
		                                                    <th>Policies </th>
		                                                    <th>Premium (Previous Year)</th>
		                                                    <th>Policies (Previous Year)</th>
		                                                </tr>
		                                            </thead>
		                                            <tbody> 
			                                            <tr role="row" class="odd" *ngFor="let ld of monthWiseData; let idx = index">
			                                            	<td><input type="checkbox" class="form-control-sm form-control" [(ngModel)]="monthCheck[ld.id]" value="{{ld.id}}-{{ld.approvedId}}"></td>
			                                                <td>{{ld.insurer}}</td>
			                                                <td>{{ld.month}}</td>
			                                                <td>{{ld.year}}</td>
			                                                <td>{{ld.lob}}</td>
			                                                <td>{{ld.premium}} <span *ngIf="ld.approvedPrem!=null">({{ld.approvedPrem}})</span></td>
			                                                <td>{{ld.policies}} <span *ngIf="ld.approvedPol!=null">({{ld.approvedPol}})</span></td>
			                                                <td>{{ld.prevPremium}} <span *ngIf="ld.approvedPrevPrem!=null">({{ld.approvedPrevPrem}})</span></td>
			                                                <td>{{ld.prevPolicies}} <span *ngIf="ld.approvedPrevPol!=null">({{ld.approvedPrevPol}})</span></td>
			                                            </tr> 
			                                            <tr><td colspan="9" *ngIf="monthWiseData.length==0"> No Unapproved Data Found.</td></tr>
		                                        	</tbody>
                                        		</table>
		                                        <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getMonthCheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                            </div>
                                            <div [ngClass]="{'tab-pane': true, 'fade': true, 'show':true, 'active':tabName === 'Form 1' }" id="nav-profile"getSegmentPdUnapproveData role="tabpanel" aria-labelledby="nav-profile-tab">
                                                <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr1CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
		                                            <thead>
		                                                <tr role="row">
		                                                    <th><input type="checkbox" name="selectAll" (change)="selectUnselectQtr1($event)"></th>
		                                                    <th>Insurer</th>
		                                                    <th>Quarter</th>
		                                                    <th>Year</th>
		                                                    <th>LOB</th>
		                                                    <th>Location</th>
		                                                    <th>Number </th>
		                                                    <th>Amount </th>
		                                                </tr>
		                                            </thead>
		                                            <tbody> 
			                                            <tr role="row" class="odd" *ngFor="let ld1 of qtr1WiseData; let idx = index">
			                                            	<td><input type="checkbox" class="form-control-sm form-control" [(ngModel)]="qtr1Check[ld1.id]" value="{{ld1.id}}-{{ld1.approvedId}}"></td>
			                                                <td>{{ld1.insurer}}</td>
			                                                <td>{{ld1.quarter}}</td>
			                                                <td>{{ld1.year}}</td>
			                                                <td>{{ld1.lob}}</td>
			                                                <td>{{ld1.locOrChannel}}</td>
			                                                <td>{{ld1.polOrClaim}} <span *ngIf="ld1.approvedPol!=null">({{ld1.approvedPol}})</span></td>
			                                                <td>{{ld1.premOrAmt}} <span *ngIf="ld1.approvedPrem!=null">({{ld1.approvedPrem}})</span></td>
			                                            </tr> 
			                                            <tr><td colspan="8" *ngIf="qtr1WiseData.length==0"> No Unapproved Data Found.</td></tr>
		                                        	</tbody>
                                        		</table>
		                                        <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr1CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                            </div>
                                            <div [ngClass]="{'tab-pane': true, 'fade': true, 'show':true, 'active':tabName === 'Form 2' }" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                                <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr2CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
		                                            <thead>
		                                                <tr role="row">
		                                                    <th><input type="checkbox" name="selectAll" (change)="selectUnselectQtr2($event)"></th>
		                                                    <th>Insurer</th>
		                                                    <th>Quarter</th>
		                                                    <th>Year</th>
		                                                    <th>LOB</th>
		                                                    <th>Channel</th>
		                                                    <th>Number </th>
		                                                    <th>Amount </th>
		                                                </tr>
		                                            </thead>
		                                            <tbody> 
			                                            <tr role="row" class="odd" *ngFor="let ld of qtr2WiseData; let idx = index">
			                                            	<td><input type="checkbox" class="form-control-sm form-control" [(ngModel)]="qtr2Check[ld.id]" value="{{ld.id}}-{{ld.approvedId}}"></td>
			                                                <td>{{ld.insurer}}</td>
			                                                <td>{{ld.quarter}}</td>
			                                                <td>{{ld.year}}</td>
			                                                <td>{{ld.lob}}</td>
			                                                <td>{{ld.locOrChannel}}</td>
			                                                <td>{{ld.polOrClaim}} <span *ngIf="ld.approvedPol!=null">({{ld.approvedPol}})</span></td>
			                                                <td>{{ld.premOrAmt}} <span *ngIf="ld.approvedPrem!=null">({{ld.approvedPrem}})</span></td>
			                                            </tr> 
			                                             <tr><td colspan="8" *ngIf="qtr2WiseData.length==0"> No Unapproved Data Found.</td></tr>
		                                        	</tbody>
                                        		</table>
		                                        <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr2CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                            </div>


                                            <div [ngClass]="{'tab-pane': true, 'fade': true, 'show':true, 'active':tabName === 'Form 3' }" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                                <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr3CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
		                                            <thead>
		                                                <tr role="row">
		                                                    <th><input type="checkbox" name="selectAll" (change)="selectUnselectQtr3($event)"></th>
		                                                    <th>Insurer</th>
		                                                    <th>Quarter</th>
		                                                    <th>Year</th>
		                                                    <th>LOB</th>
		                                                    <th>Location</th>
		                                                    <th>Number </th>
		                                                    <th>Amount </th>
		                                                </tr>
		                                            </thead>
		                                            <tbody> 
			                                            <tr role="row" class="odd" *ngFor="let ld of qtr3WiseData; let idx = index">
			                                            	<td><input type="checkbox" class="form-control-sm form-control" [(ngModel)]="qtr3Check[ld.id]" value="{{ld.id}}-{{ld.approvedId}}"></td>
			                                                <td>{{ld.insurer}}</td>
			                                                <td>{{ld.quarter}}</td>
			                                                <td>{{ld.year}}</td>
			                                                <td>{{ld.lob}}</td>
			                                                <td>{{ld.locOrChannel}}</td>
			                                                <td>{{ld.polOrClaim}} <span *ngIf="ld.approvedPol!=null">({{ld.approvedPol}})</span></td>
			                                                <td>{{ld.premOrAmt}} <span *ngIf="ld.approvedPrem!=null">({{ld.approvedPrem}})</span></td>
			                                            </tr> 
			                                             <tr><td colspan="8" *ngIf="qtr3WiseData.length==0"> No Unapproved Data Found.</td></tr>
		                                        	</tbody>
                                        		</table>
		                                        <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr3CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                            </div>

                                            <div [ngClass]="{'tab-pane': true, 'fade': true, 'show':true, 'active':tabName === 'Form 5' }" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                                <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr5CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
		                                            <thead>
		                                                <tr role="row">
		                                                    <th><input type="checkbox" name="selectAll" (change)="selectUnselectQtr5($event)"></th>
		                                                    <th>Insurer</th>
		                                                    <th>Quarter</th>
		                                                    <th>Year</th>
		                                                    <th>LOB</th>
		                                                    <th>Channel</th>
		                                                    <th>Number </th>
		                                                    <th>Amount </th>
		                                                </tr>
		                                            </thead>
		                                            <tbody> 
			                                            <tr role="row" class="odd" *ngFor="let ld of qtr5WiseData; let idx = index">
			                                            	<td><input type="checkbox" class="form-control-sm form-control" [(ngModel)]="qtr5Check[ld.id]" value="{{ld.id}}-{{ld.approvedId}}"></td>
			                                                <td>{{ld.insurer}}</td>
			                                                <td>{{ld.quarter}}</td>
			                                                <td>{{ld.year}}</td>
			                                                <td>{{ld.lob}}</td>
			                                                <td>{{ld.locOrChannel}}</td>
			                                                <td>{{ld.polOrClaim}} <span *ngIf="ld.approvedPol!=null">({{ld.approvedPol}})</span></td>
			                                                <td>{{ld.premOrAmt}} <span *ngIf="ld.approvedPrem!=null">({{ld.approvedPrem}})</span></td>
			                                            </tr> 
			                                             <tr><td colspan="8" *ngIf="qtr5WiseData.length==0"> No Unapproved Data Found.</td></tr>
		                                        	</tbody>
                                        		</table>
		                                        <div class="col-12 col-md-12">
			                                        <div class="form-actions form-group">
			                                            <button type="submit" class="btn btn-primary btn-sm" (click)="getQtr5CheckVal()" >Approve</button>
			                                             
			                                        </div>
		                                    	</div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


<div class="loaderbox" *ngIf="loaderVisibility">
    <div class="load">
        <img src="assets/images/loading.gif" alt="">
    </div>
</div>














				</div>
			</div>
		</div>
	</div>
</div>
